import React from 'react';
import {withTranslation} from 'react-i18next';

const AccountNumberHelperModal = (props) => {
    const { t, i18n } = props;

    return (
        <div className="invoices-square row row--rmline">
            <div className="col-12 col-md-6 mb-4">
                <div className="invoices-square__box text-center d-flex flex-column">
                    <img src="/images/invoices/releve.png"
                         title={i18n.language === "fr" ? 'Relevé de compte' : 'Account statement'} />
                    <strong className="text-uppercase">
                        {i18n.language === "fr" ? 'Relevé de compte' : 'Account statement'}
                    </strong>
                </div>
            </div>
            <div className="col-12 col-md-6 mb-4">
                <div
                    className="invoices-square__box text-center  d-flex flex-column">
                    <img
                        src="/images/invoices/facture.png"
                        title={t('linkedaccounts.modalhelper.invoice')}/>
                    <strong className="text-uppercase">
                        {t('linkedaccounts.modalhelper.invoice')}
                    </strong>
                </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
                <div
                    className="invoices-square__box text-center d-flex flex-column">
                    <img
                        src="/images/invoices/bon-livraison.png"
                        title={t('linkedaccounts.modalhelper.bonliv')} />
                    <strong className=" text-uppercase">
                        {t('linkedaccounts.modalhelper.bonliv')}
                    </strong>
                </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
                <div
                    className="invoices-square__box text-center d-flex flex-column ">
                    <img
                        src="/images/invoices/bon-lubrifiant.png"
                        title={t('linkedaccounts.modalhelper.bonlub')}/>
                    <strong className="text-uppercase">
                        {t('linkedaccounts.modalhelper.bonlub')}
                    </strong>
                </div>
            </div>
        </div>
    );
}

export default withTranslation()(AccountNumberHelperModal);
